export const OFFICIAL_LINKS = {
  phone: '8247814987',
  phoneFormatted: '+91 8247814987',
  whatsappUrl: 'https://wa.me/918247814987?text=Hello%20Fi%20Pay%20Bills,%20I%20am%20interested%20in%20your%20fintech%20and%20banking%20solutions.',
  location: 'Hyderabad, Telangana, India',
  website: 'https://fipaybills.com',
  razorpayReferral: 'https://accounts.razorpay.com/auth/?redirecturl=https%3A%2F%2Feasy.razorpay.com&auth_intent=signup&eo=1&kyc_access=1&partner_id=TLGUbd99035zSK&partner_type=reseller&referral_code=sairamsnyi6jac&user_type=sub-merchant&x-country-code=IN',
  cashfreeReferral: 'https://merchant.cashfree.com/merchants/signup?referrer=partner&refCode=CFPAY206682',
};

export const SUPPORTED_INDIAN_BANKS = [
  'State Bank of India (SBI)',
  'HDFC Bank',
  'ICICI Bank',
  'Axis Bank',
  'Kotak Mahindra Bank',
  'Punjab National Bank (PNB)',
  'Bank of Baroda (BoB)',
  'Canara Bank',
  'IndusInd Bank',
  'Yes Bank',
  'Union Bank of India',
  'IDFC FIRST Bank',
  'Federal Bank',
  'Indian Bank',
  'Central Bank of India',
  'RBL Bank'
];

export const SOLUTION_CATEGORIES = [
  { id: 'pay-in', label: 'Payment Gateway (Pay-In)', icon: 'CreditCard', badge: 'All Gateways' },
  { id: 'payout', label: 'Instant Payouts & All Banks', icon: 'Send', badge: 'T+0 / T+1 Live' },
  { id: 'validation', label: 'Validation Kit (All APIs)', icon: 'FileCheck', isGreen: true, badge: 'Full Suite' },
  { id: 'loans', label: 'Loans & EMI Calculator', icon: 'Coins', badge: 'Highlighted' },
  { id: 'api-services', label: 'Fintech APIs (14+ APIs)', icon: 'Terminal', isGreen: true, badge: 'REST POST' },
  { id: 'pos', label: 'Smart POS & Soundboxes', icon: 'Smartphone' },
  { id: 'banking', label: 'Banking & Accounts', icon: 'Landmark' },
  { id: 'insurance', label: 'Insurance Portal (IRDA)', icon: 'ShieldCheck', isGreen: true, badge: 'Live' },
  { id: 'build-invest', label: 'Build & Invest', icon: 'Rocket' },
];

export const SERVICES_LIST = [
  // ================= PAY-IN SOLUTIONS =================
  {
    id: 'pay-in-gateway',
    title: 'Payment Gateway (Pay-In)',
    shortTag: 'Multi-Gateway Aggregation',
    category: 'pay-in',
    colorTheme: 'blue',
    iconType: 'CreditCard',
    tagline: 'All Indian payment gateway aggregators on a single unified onboarding rail.',
    description: 'Accept seamless pay-ins from customers via UPI, QR Codes, Credit/Debit cards, Net Banking, and Wallets using top Indian payment gateway aggregators.',
    partnerIntegrations: ['PhonePe', 'Paytm', 'Razorpay', 'Cashfree', 'Unlimit', 'Subpaisa'],
    settlementTime: 'Instant / T+0 Settlement',
    whatWeProvide: [
      'Official aggregator pipelines with PhonePe, Paytm, Razorpay, Cashfree, Unlimit, and Subpaisa',
      'Dynamic UPI QR code generation and intent-based mobile checkout flows',
      'Direct merchant bank settlement with T+0 and instant settlement capabilities',
      'Smart failover cascade routing delivering 99.8% payment success rate',
      'Lowest MDR transaction slabs for retail, D2C, and enterprise merchants',
      'Sub-merchant onboarding with automated express KYC verification'
    ],
    referralLink: OFFICIAL_LINKS.razorpayReferral,
    directActionText: 'Submit Request',
  },
  {
    id: 'subpaisa-aggregator',
    title: 'Subpaisa Payment Suite',
    shortTag: 'Express Subpaisa Onboarding',
    category: 'pay-in',
    colorTheme: 'blue',
    iconType: 'Zap',
    tagline: 'High-volume payment aggregation with custom merchant checkout and lowest MDR.',
    description: 'Direct Subpaisa integration for educational institutions, government portals, utilities, and high-growth retail brands.',
    partnerIntegrations: ['Subpaisa', 'UPI 2.0', 'RuPay', 'All Major Cards'],
    settlementTime: 'T+0 & T+1 Real-time',
    whatWeProvide: [
      'Direct merchant onboarding on Subpaisa platform with swift documentation approval',
      'Multi-option checkout supporting Net Banking of 50+ Indian banks, Cards, and UPI',
      'Dedicated fee collection engine for schools, colleges, institutions, and utility providers',
      'Instant settlement options with comprehensive refund and dispute dashboards',
      'Dedicated relationship manager and 24/7 technical API integration desk'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'upi-collections',
    title: 'UPI Intent & Dynamic QR Suite',
    shortTag: 'Instant UPI Checkout',
    category: 'pay-in',
    colorTheme: 'blue',
    iconType: 'QrCode',
    tagline: 'Zero-drop UPI intent payment integration for websites and mobile applications.',
    description: 'Direct deep-link integration into Google Pay, PhonePe, Paytm, and BHIM with real-time webhooks.',
    partnerIntegrations: ['PhonePe', 'Paytm', 'Razorpay', 'Cashfree', 'Subpaisa'],
    settlementTime: 'Real-time T+0',
    whatWeProvide: [
      'Deep-linking into Google Pay, PhonePe, Paytm, CRED, and BHIM',
      'Dynamic merchant UPI QR codes generated per bill or order with automated expiry',
      'Automated reconciliation engine with instant webhook push notifications',
      'Zero customer drop-off with auto-read OTP & seamless UPI pin input'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'net-banking-card-switch',
    title: 'Multi-Bank Card & Net Banking Switch',
    shortTag: 'All Indian Banks & Cards',
    category: 'pay-in',
    colorTheme: 'blue',
    iconType: 'Landmark',
    tagline: 'Direct switch connectivity to 50+ Indian banks, RuPay, Visa, and Mastercard.',
    description: 'Provide high-availability retail checkout with direct bank switch connections and zero third-party hops.',
    partnerIntegrations: ['SBI', 'HDFC', 'ICICI', 'Axis', 'RuPay', 'Visa', 'Mastercard'],
    settlementTime: 'T+0 / Next Day T+1',
    whatWeProvide: [
      'Direct Net Banking connectivity across 50+ scheduled commercial and public banks',
      'Support for RuPay Debit/Credit, Visa, Mastercard, American Express, and Diners',
      'No-cost EMI and low-cost EMI checkout on top 14 credit card issuers',
      'Real-time transaction retry logic reducing customer drop-offs'
    ],
    directActionText: 'Submit Request',
  },

  // ================= PAYOUT SOLUTIONS =================
  {
    id: 'instant-payouts',
    title: 'Instant Payouts & Disbursals',
    shortTag: 'Merchant to Customer Payouts',
    category: 'payout',
    colorTheme: 'blue',
    iconType: 'Send',
    tagline: 'Instant 24/7 fund transfers from merchant bank accounts to customer accounts.',
    description: 'Automate bulk disbursements, vendor settlements, referral payouts, and refund processing in real-time across all Indian banks.',
    partnerIntegrations: ['Cashfree Payouts', 'RazorpayX', 'ICICI Bank', 'Yes Bank', 'Axis Bank', 'Subpaisa'],
    settlementTime: 'Sub-second real-time (T+0 / T+1)',
    whatWeProvide: [
      'Direct merchant bank account to beneficiary customer account transfers within milliseconds',
      '24/7/365 instant payout rails via IMPS, NEFT, RTGS, and UPI handles',
      'Complete support for All Major Indian Banks (SBI, HDFC, ICICI, Axis, Kotak, PNB, BoB, Canara, IndusInd, Federal, Yes Bank)',
      'Single and bulk Excel/CSV file upload with automated retry logic and zero manual friction',
      'Pre-debit beneficiary name validation (penny drop) to eliminate failed transfers',
      'Custom maker-checker role permissions and two-factor approval controls'
    ],
    referralLink: OFFICIAL_LINKS.cashfreeReferral,
    directActionText: 'Submit Request',
  },
  {
    id: 'bulk-vendor-payouts',
    title: 'Bulk Vendor & Salary Payout Engine',
    shortTag: 'Multi-Bank Bulk Rails',
    category: 'payout',
    colorTheme: 'blue',
    iconType: 'Building',
    tagline: 'Schedule and disperse thousands of vendor payments with one single click.',
    description: 'Connect existing ERPs or accounting software directly with automated payout switches.',
    partnerIntegrations: ['SBI', 'HDFC', 'ICICI', 'Axis', 'Cashfree', 'RazorpayX'],
    settlementTime: 'Instant T+0 batch disbursal',
    whatWeProvide: [
      'Bulk batch payout processing of 10,000+ simultaneous transfers with sub-second confirmation',
      'Automated tax deduction (TDS) computation and vendor statement generation',
      'Instant SMS and Email alerts to beneficiaries with transaction UTR numbers',
      'Smart multi-bank load balancing to prevent bank node downtime failures'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'connected-banking-payouts',
    title: 'Connected Corporate Banking Payouts',
    shortTag: 'Direct Bank Node APIs',
    category: 'payout',
    colorTheme: 'blue',
    iconType: 'Landmark',
    tagline: 'Direct corporate banking API integration for real-time balance queries and transfers.',
    description: 'Link your existing current accounts without having to manually fund third-party escrow pools.',
    partnerIntegrations: ['ICICI CIB', 'HDFC Corporate API', 'Axis Bank API', 'Yes Bank Smart API'],
    settlementTime: 'Real-time T+0',
    whatWeProvide: [
      'Direct API handshake with your primary business current account',
      'Real-time account balance tracking and automated ledger posting',
      'Configurable transaction limits, daily caps, and IP whitelisting for highest safety',
      'Automatic failover routing to secondary bank nodes'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'upi-auto-payouts',
    title: 'Instant UPI Handle Disbursals',
    shortTag: 'VPA Instant Payout',
    category: 'payout',
    colorTheme: 'blue',
    iconType: 'QrCode',
    tagline: 'Disburse refunds and rewards directly to customer UPI IDs in seconds.',
    description: 'Zero account number or IFSC requirement. Instant payment delivery directly to beneficiary UPI VPAs.',
    partnerIntegrations: ['NPCI UPI Switch', 'Cashfree', 'RazorpayX', 'All PSPs'],
    settlementTime: '< 500ms delivery',
    whatWeProvide: [
      'Single and bulk payouts directly using beneficiary UPI VPAs (e.g. mobile@upi)',
      'Pre-validation of UPI ID before sending money to prevent lost funds',
      'Real-time webhook notifications with official bank UTR',
      'Ideal for gaming prize payouts, cashback distributions, and instant ecommerce refunds'
    ],
    directActionText: 'Submit Request',
  },

  // ================= VALIDATION KIT =================
  {
    id: 'validation-kit-suite',
    title: 'Complete Enterprise Validation Kit',
    shortTag: 'All-in-One Identity Stack',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'Layers',
    tagline: 'Unified suite packaging PAN, Aadhaar, Bank Details, GSTIN, and Voter ID verification.',
    description: 'Single API key granting access to 25+ real-time customer and business verification endpoints for automated onboarding.',
    partnerIntegrations: ['NSDL', 'UIDAI', 'NPCI', 'GSTN', 'MCA', 'DigiLocker'],
    settlementTime: 'Instant (< 250ms API)',
    whatWeProvide: [
      'Single master API key for complete identity, banking, and business compliance checks',
      'PAN Card verification with full taxpayer legal name, status, and Aadhaar link status',
      'Aadhaar number validation & paperless OTP e-KYC with UIDAI registry',
      'Bank Account Penny Drop verification with instant legal account holder name match',
      'UPI VPA verification to validate handle existence and registered customer name',
      'GSTIN verification returning business trade name, tax return filing dates, and active status',
      'Company CIN / DIN verification checking Ministry of Corporate Affairs (MCA) records',
      'Ready-to-use SDKs for Node.js, Python, PHP, Java, and Postman collections'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'pan-validation-kit',
    title: 'PAN Verification & Validation API',
    shortTag: 'Instant PAN Check',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'ShieldCheck',
    tagline: 'Instant PAN verification checking status, category, taxpayer name, and Aadhaar seeding.',
    description: 'Verify individual, proprietorship, LLP, and corporate PAN numbers directly against NSDL and Income Tax Department records.',
    partnerIntegrations: ['NSDL', 'Income Tax Department (ITD)'],
    settlementTime: '< 200ms real-time',
    whatWeProvide: [
      'Validates 10-digit PAN number against central Income Tax database',
      'Returns complete taxpayer legal name, status (Operative/Inoperative), and issue date',
      'Checks real-time Aadhaar-PAN linkage compliance as required by RBI/SEBI',
      'Entity categorization: Individual, Firm, Company, Trust, Association of Persons',
      'Anti-fraud matching against stolen or duplicate PAN databases'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'aadhaar-validation-kit',
    title: 'Aadhaar Validation & OTP e-KYC API',
    shortTag: 'UIDAI Aadhaar Rails',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'FileCheck',
    tagline: 'Instant Aadhaar card number validation, demographic verification, and paperless e-KYC.',
    description: 'Confirm Aadhaar authenticity, age band, gender, state, mobile number linkage, or execute OTP-based e-KYC.',
    partnerIntegrations: ['UIDAI Licensed Rails', 'DigiLocker'],
    settlementTime: '< 300ms real-time',
    whatWeProvide: [
      'Instant validation of 12-digit Aadhaar number against UIDAI registry',
      'Returns age band, gender, state, and masked linked mobile number',
      'Aadhaar OTP-based paperless e-KYC returning digitally signed XML with verified photo and address',
      'Biometric fingerprint & iris integration support for field agents and retail BCs',
      'Full compliance with RBI, SEBI, and IRDAI electronic customer verification regulations'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'bank-penny-drop-kit',
    title: 'Bank Details & Penny Drop API',
    shortTag: 'Account & Name Validation',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'Coins',
    tagline: 'Bank account verification via instant ₹1 penny drop with registered name match.',
    description: 'Verify beneficiary bank account number and IFSC code before disbursement or merchant onboarding across all Indian banks.',
    partnerIntegrations: ['NPCI IMPS Switch', 'All Scheduled Commercial Banks'],
    settlementTime: 'Sub-second real-time',
    whatWeProvide: [
      'Deposits nominal ₹1 into beneficiary account to verify active bank status',
      'Retrieves the exact legal name registered at the beneficiary bank branch',
      'Advanced Levenshtein fuzzy matching algorithm to score applicant name match percentage',
      'Supports all scheduled commercial, cooperative, and regional rural banks in India',
      'Eliminates payout bounce fees and wrong account transfer risks'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'upi-vpa-validation-kit',
    title: 'UPI VPA & Handle Verification API',
    shortTag: 'Instant VPA Check',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'QrCode',
    tagline: 'Validate UPI VPA handle and fetch customer registered legal name instantly.',
    description: 'Verify any UPI ID (e.g. mobile@upi, username@okhdfcbank) before routing payments or refunds.',
    partnerIntegrations: ['NPCI UPI Switch', 'PSP Banks'],
    settlementTime: '< 180ms',
    whatWeProvide: [
      'Validates whether the provided VPA handle is live and active on the NPCI network',
      'Returns verified account holder name associated with the UPI handle',
      'Prevents transfer errors, wrong payee disputes, and chargebacks',
      'High-throughput rate limit supporting up to 5,000 validations per minute'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'gstin-validation-kit',
    title: 'GSTIN Business Verification API',
    shortTag: 'Commercial Tax Check',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'Building2',
    tagline: 'Verify business GST numbers, trade legal name, filing track record, and status.',
    description: 'Direct handshake with GSTN portal for corporate merchant verification and credit assessment.',
    partnerIntegrations: ['GSTN Central Registry', 'CBIC'],
    settlementTime: '< 300ms',
    whatWeProvide: [
      'Verifies 15-character GSTIN against central tax database',
      'Returns Legal Trade Name, Constitution of Business, and Principal Place of Business',
      'Provides GST filing history for GSTR-1 and GSTR-3B to gauge business activity',
      'Detects canceled, suspended, or inactive GST numbers automatically'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'photo-ocr-validation-kit',
    title: 'Photo ID OCR (PAN / Aadhaar / DL / Voter)',
    shortTag: 'AI Document Extraction',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'ScanText',
    tagline: 'AI-powered OCR extraction and tamper detection for physical ID cards.',
    description: 'Extract text, numbers, dates, and addresses from uploaded images with automatic forgery detection.',
    partnerIntegrations: ['Vision AI Engine', 'DocuTamper Detect'],
    settlementTime: '< 400ms OCR speed',
    whatWeProvide: [
      'High-accuracy extraction of Name, Father Name, DOB, Gender, ID Number, and Address',
      'Supports front and back document stitching and auto-crop alignment',
      'Digital tampering detection: highlights altered fonts, pixel irregularities, and screen photo spoofs',
      'Eliminates manual data entry errors in merchant onboarding forms'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'dl-voter-validation-kit',
    title: 'Driving License & Voter ID API',
    shortTag: 'Government Identity Rails',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'FileCheck',
    tagline: 'Instant Driving License and Voter ID verification against state RTO & ECI records.',
    description: 'Verify field staff, logistics drivers, and customer identity documents with verified government records.',
    partnerIntegrations: ['Sarathi Parivahan', 'Election Commission of India (ECI)'],
    settlementTime: '< 350ms',
    whatWeProvide: [
      'Validates Driving License number and DOB against Sarathi central database',
      'Returns vehicle class authorizations (MCWG, LMV, Transport) and validity dates',
      'Voter ID (EPIC) verification retrieving polling station, constituency, and voter name',
      'Zero manual verification required for logistics, transport, and delivery fleets'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'mca-company-validation-kit',
    title: 'MCA CIN & Director DIN Verification API',
    shortTag: 'Corporate Registry',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'Building',
    tagline: 'Verify registered companies, LLPs, authorized capital, and director credentials.',
    description: 'Direct handshake with the Ministry of Corporate Affairs (MCA) database for B2B compliance.',
    partnerIntegrations: ['Ministry of Corporate Affairs (MCA)', 'RoC'],
    settlementTime: '< 500ms',
    whatWeProvide: [
      'Validates 21-digit Corporate Identity Number (CIN) and LLPIN registration',
      'Returns company incorporation date, authorized capital, paid-up capital, and status',
      'Fetches complete active Director Identification Numbers (DIN) and names',
      'Crucial for underwriting enterprise vendor contracts and business loans'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'vehicle-rc-validation-kit',
    title: 'Vehicle RC & Fastag Verification API',
    shortTag: 'Parivahan Vehicle Database',
    category: 'validation',
    colorTheme: 'green',
    iconType: 'Car',
    tagline: 'Verify commercial and private vehicle registration certificates in real-time.',
    description: 'Check vehicle chassis number, engine number, insurance status, and pollution validity.',
    partnerIntegrations: ['Vahan Central Registry', 'National Informatics Centre (NIC)'],
    settlementTime: '< 400ms',
    whatWeProvide: [
      'Validates vehicle registration plate number against central Vahan registry',
      'Returns Owner Name, Vehicle Class, Fuel Type, Registration Date, and Fitness Validity',
      'Fetches active vehicle insurance policy number and expiration date',
      'Checks vehicle hypothecation / loan financier status'
    ],
    directActionText: 'Submit Request',
  },

  // ================= LOANS & EMI CALCULATOR (HIGHLIGHTED) =================
  {
    id: 'business-loan',
    title: 'Business & MSME Loans',
    shortTag: 'Collateral-Free Capital',
    category: 'loans',
    colorTheme: 'blue',
    iconType: 'Building2',
    tagline: 'Unsecured working capital up to ₹2 Crores with multi-lender loan platform.',
    description: 'Fast-track funding for business expansion, equipment purchase, and inventory financing with our multi-lender platform.',
    partnerIntegrations: ['Tata Capital', 'Bajaj Finserv', 'HDFC Bank', 'Lendingkart', 'IIFL', 'Kotak'],
    commissionInfo: 'Refer & Earn: Up to 2.5% DSA commission on sanctioned amount',
    whatWeProvide: [
      'Multi-lender loan platform connecting with 15+ top NBFCs and banks simultaneously',
      'Collateral-free unsecured business loans from ₹2 Lakhs up to ₹2 Crores',
      'Competitive interest rates starting from 12.5% per annum with flexible tenures',
      'Rapid sanction within 48 hours based on banking turnover and GST filings',
      'Interactive Loan & EMI Calculator to calculate installments and commission payouts',
      'Direct account credit with transparent processing fees and zero hidden charges'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'personal-loan',
    title: 'Personal Loans',
    shortTag: 'Instant Cash Loans',
    category: 'loans',
    colorTheme: 'blue',
    iconType: 'Coins',
    tagline: 'Instant personal loans up to ₹40 Lakhs with minimal documentation.',
    description: 'Quick personal financing for salaried and self-employed professionals with soft credit check.',
    partnerIntegrations: ['HDFC Bank', 'ICICI Bank', 'Kotak Mahindra Bank', 'Axis Bank', 'Bajaj Finserv'],
    commissionInfo: 'Refer & Earn: Up to 2.0% DSA commission',
    whatWeProvide: [
      'Instant personal loans from ₹50,000 up to ₹40 Lakhs',
      'Sanctions starting from 10.49% p.a. with zero prepayment penalties on select banks',
      'Soft credit check with in-principle sanction in 60 seconds',
      'Direct account credit within 24 hours of document submission',
      'Use our Loan EMI Calculator to plan your monthly budget accurately'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'home-loan',
    title: 'Home Loans & Loan Against Property (LAP)',
    shortTag: 'High-Ticket Secured Loans',
    category: 'loans',
    colorTheme: 'blue',
    iconType: 'Home',
    tagline: 'Low interest rates starting from 8.35% p.a. with tenures up to 30 years.',
    description: 'Secured loans for residential property purchase, construction, or mortgage against commercial property.',
    partnerIntegrations: ['SBI', 'HDFC Bank', 'ICICI Bank', 'LIC Housing Finance', 'PNB Housing'],
    commissionInfo: 'Refer & Earn: Up to 1.0% on high-ticket loans',
    whatWeProvide: [
      'Home loan sanctions from ₹10 Lakhs up to ₹25 Crores',
      'Attractive floating rates starting from 8.35% per annum',
      'Loan against property (LAP) against residential, commercial, or industrial units',
      'Doorstep document collection and expert legal vetting support',
      'Comprehensive EMI calculation with amortized tenure breakdown'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'equipment-machinery-loan',
    title: 'Equipment & Machinery Financing',
    shortTag: 'Industrial & Medical Assets',
    category: 'loans',
    colorTheme: 'blue',
    iconType: 'Wrench',
    tagline: 'Specialized asset funding for manufacturing units, diagnostic centers, and printing presses.',
    description: 'Finance up to 90% of equipment purchase value with customized structured repayment schedules.',
    partnerIntegrations: ['Tata Capital', 'Siemens Financial', 'Kotak MSME', 'SIDBI'],
    commissionInfo: 'Refer & Earn: Up to 1.5% DSA payout',
    whatWeProvide: [
      'Financing up to 90% on invoice value of new machinery and commercial assets',
      'Moratorium period during asset installation and commissioning',
      'Competitive interest slabs with tenures up to 7 years',
      'Hypothecation solely on the procured machinery without additional collateral'
    ],
    directActionText: 'Submit Request',
  },

  // ================= API SERVICES (FULL SUITE) =================
  {
    id: 'api-payout',
    title: 'PAYOUT API',
    shortTag: 'API SERVICES',
    category: 'api-services',
    colorTheme: 'green',
    iconType: 'Send',
    tagline: 'Direct bulk & instant fund disbursals via sub-second REST API.',
    description: 'Automate merchant-to-customer transfers, vendor clearing, and employee salary payouts 24/7 across all banks.',
    partnerIntegrations: ['NPCI', 'IMPS', 'NEFT', 'RTGS', 'UPI Rails', 'All Banks'],
    settlementTime: '< 1 sec response',
    whatWeProvide: [
      'REST POST API for single and bulk disbursal execution',
      'Support for All Indian Banks with automated routing',
      'Real-time account balance verification and automated retry queue',
      'Webhook callback alerts on successful transaction settlement',
      'Bank-grade 256-bit AES encrypted payload signing'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'api-aeps',
    title: 'AEPS API',
    shortTag: 'API SERVICES',
    category: 'api-services',
    colorTheme: 'green',
    iconType: 'Fingerprint',
    tagline: 'Aadhaar Enabled Payment System for biometric cash withdrawal and balance enquiry.',
    description: 'Empower retail outlets and BC agents to deliver banking services using Aadhaar biometric authentication.',
    partnerIntegrations: ['UIDAI', 'NPCI', 'Partner Banks'],
    settlementTime: 'Real-time T+0',
    whatWeProvide: [
      'Aadhaar Cash Withdrawal (CW) API',
      'Balance Enquiry (BE) and Mini-Statement (MS) APIs',
      'Aadhaar Pay for high-limit merchant collections',
      'Support for Mantra, Morpho, and Startek biometric RD services'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'api-matm',
    title: 'MATM API',
    shortTag: 'API SERVICES',
    category: 'api-services',
    colorTheme: 'green',
    iconType: 'CreditCard',
    tagline: 'Micro-ATM API for debit card cash withdrawal and PIN verification.',
    description: 'Transform Bluetooth and USB card swipe devices into portable automated teller machines.',
    partnerIntegrations: ['NPCI RuPay', 'Visa', 'Mastercard'],
    settlementTime: 'Instant wallet credit',
    whatWeProvide: [
      'Debit card cashout API integration with EMV Chip & PIN certification',
      'Zero bounce rate with direct switch routing to issuing banks',
      'SDK support for Android, Windows, and Web POS terminals',
      'Instant settlement into agent wallet and merchant bank account'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'api-dmt',
    title: 'DMT API',
    shortTag: 'API SERVICES',
    category: 'api-services',
    colorTheme: 'green',
    iconType: 'ArrowRightLeft',
    tagline: 'Domestic Money Transfer API for instant unbanked cash transfers.',
    description: 'Enable customers to deposit cash and transfer directly to any bank account across India 24/7.',
    partnerIntegrations: ['IMPS Rails', 'NEFT', 'NPCI', 'All Banks'],
    settlementTime: 'Instant 24/7',
    whatWeProvide: [
      'Sender mobile OTP registration and monthly KYC limit check',
      'Beneficiary addition with instant account validation',
      'Instant IMPS funds routing with 99.9% success rate',
      'Automated receipt generation and SMS confirmation push'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'api-cms',
    title: 'CMS API',
    shortTag: 'API SERVICES',
    category: 'api-services',
    colorTheme: 'green',
    iconType: 'Building',
    tagline: 'Cash Management Services API for 100+ NBFCs, loan EMIs, and delivery agents.',
    description: 'Collect loan repayments, insurance premiums, and cash-on-delivery payments seamlessly.',
    partnerIntegrations: ['Bajaj', 'L&T', 'Hero FinCorp', 'Zomato', 'Swiggy', 'Delhivery'],
    settlementTime: 'Real-time reconciliation',
    whatWeProvide: [
      'Over 100+ billers, microfinance institutions, and logistics networks integrated',
      'Instant payment receipt and ledger reconciliation API',
      'Highest retailer and agent commission on cash collections',
      'Zero dispute handling with digital OTP validation'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'api-recharge',
    title: 'RECHARGE & BBPS API',
    shortTag: 'API SERVICES',
    category: 'api-services',
    colorTheme: 'green',
    iconType: 'Smartphone',
    tagline: 'All-in-one Prepaid Mobile, DTH, Fastag, and BBPS Utility Recharge API.',
    description: 'Instant recharge and bill payment API for Airtel, Jio, VI, BSNL, Tata Play, and State Electricity Boards.',
    partnerIntegrations: ['Bharat BillPay (BBPS)', 'NPCI', 'Telecom Operators'],
    settlementTime: 'Instant (< 200ms)',
    whatWeProvide: [
      'Prepaid mobile & DTH top-up API with live plan fetch (HLR lookup)',
      'BBPS utility bill fetch and payment for electricity, gas, water, and broadband',
      'Fastag recharge across all national highway toll banks',
      'Competitive commission margins with automated failover routing'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'api-travel',
    title: 'TRAVEL API',
    shortTag: 'API SERVICES',
    category: 'api-services',
    colorTheme: 'green',
    iconType: 'Plane',
    tagline: 'Travel APIs for Flight ticketing, IRCTC Trains, Inter-City Buses, and Hotels.',
    description: 'Integrate live travel booking, seat selection, cancellation, and refund management into your portal.',
    partnerIntegrations: ['Amadeus', 'IRCTC', 'RedBus GDS', 'TBO Travel'],
    settlementTime: 'Real-time PNR generation',
    whatWeProvide: [
      'Domestic & International Flight search, fare rules, and instant booking API',
      'IRCTC authorized Train booking, live PNR status, and seat availability',
      'Inter-city Bus ticketing API covering 3,000+ bus operators across India',
      'Custom travel POST APIs available upon request with special markup commissions'
    ],
    directActionText: 'Submit Request',
  },

  // ================= SMART POS & SOUNDBOXES =================
  {
    id: 'smart-pos-terminals',
    title: 'Smart Android POS Machines',
    shortTag: 'In-Store Card & QR Terminal',
    category: 'pos',
    colorTheme: 'blue',
    iconType: 'Smartphone',
    tagline: 'All-in-one wireless swipe machines accepting Tap & Pay, Chip cards, and UPI.',
    description: 'Full-featured Android smart POS machines deployed with top payment brand hardware.',
    partnerIntegrations: ['PhonePe', 'Paytm', 'BharatPe', 'Pine Labs'],
    settlementTime: 'Next-day T+1 / Same-day T+0',
    whatWeProvide: [
      'Official hardware supply from PhonePe, Paytm, BharatPe, and Pine Labs',
      'Accepts Contactless NFC (Tap & Pay), Chip cards, Magstripe, and Dynamic QR',
      'Direct settlement into your designated merchant current or savings bank account',
      'Doorstep terminal dispatch, setup, and merchant staff training',
      'Competitive monthly rental models and lowest in-store card MDR'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'audio-soundbox',
    title: 'Multilingual Audio Soundboxes',
    shortTag: 'Voice Payment Alerts',
    category: 'pos',
    colorTheme: 'blue',
    iconType: 'Volume2',
    tagline: 'Instant loud voice alerts for every UPI QR transaction in local languages.',
    description: 'Eliminates payment fraud with immediate audio broadcasting in Hindi, Telugu, English, Tamil, and more.',
    partnerIntegrations: ['PhonePe', 'Paytm', 'BharatPe'],
    settlementTime: 'Instant into bank account',
    whatWeProvide: [
      'Instant voice confirmation in Telugu, Hindi, English, Kannada, and regional languages',
      'High-volume speaker engineered for busy shops, supermarkets, and restaurants',
      'Pre-activated 4G SIM card included with long-lasting rechargeable battery',
      'Dynamic or static merchant QR display stand included'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'dual-screen-touch-pos',
    title: 'Dual-Screen Retail Billing POS',
    shortTag: 'Customer Display & Card Reader',
    category: 'pos',
    colorTheme: 'blue',
    iconType: 'Monitor',
    tagline: 'Enterprise retail countertop POS with secondary customer-facing dynamic QR screen.',
    description: 'Built for supermarkets, pharmacies, apparel stores, and restaurants with built-in thermal printer.',
    partnerIntegrations: ['Pine Labs', 'Paytm POS', 'Ingenico'],
    settlementTime: 'Direct T+0 Bank Settlement',
    whatWeProvide: [
      'High-resolution touchscreen display with secondary customer-facing dynamic QR terminal',
      'Integrated high-speed 58mm thermal receipt printer',
      'Barcode and 2D QR scanner support for instant SKU billing',
      'Pre-loaded retail inventory and GST accounting software'
    ],
    directActionText: 'Submit Request',
  },

  // ================= BANKING SOLUTIONS =================
  {
    id: 'merchant-banking',
    title: 'Merchant Banking & Current Accounts',
    shortTag: 'Digital Business Banking',
    category: 'banking',
    colorTheme: 'blue',
    iconType: 'Landmark',
    tagline: 'High-limit commercial banking accounts tailored for fast-growing businesses.',
    description: 'Zero-balance business current accounts, overdraft facilities, and seamless digital corporate banking across premier banks.',
    partnerIntegrations: ['HDFC Bank', 'ICICI Bank', 'Axis Bank', 'Kotak Mahindra Bank', 'Yes Bank', 'SBI'],
    settlementTime: 'Real-time liquidity',
    whatWeProvide: [
      'Zero-balance and premium current accounts for proprietorships, LLPs, and Pvt Ltd',
      'High daily transaction limits with preferential RTGS/NEFT/IMPS charges',
      'Merchant overdraft (OD) facility against daily payment gateway settlements',
      'Dedicated corporate relationship manager support'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'credit-cards',
    title: 'Business & Commercial Credit Cards',
    shortTag: 'Working Capital & Rewards',
    category: 'banking',
    colorTheme: 'blue',
    iconType: 'CreditCard',
    tagline: 'Pre-approved corporate credit cards with extended interest-free credit periods.',
    description: 'Access high credit limits for vendor bill payments, ad spend, and inventory purchases.',
    partnerIntegrations: ['HDFC Bank', 'ICICI Bank', 'SBI Card', 'Axis Bank'],
    settlementTime: 'Express approval',
    whatWeProvide: [
      'Up to 50 days interest-free credit period on business expenditure',
      'High credit limit sanctions based on POS and payment gateway turnovers',
      'Attractive cashback and fuel surcharge waiver benefits',
      'Paperless digital onboarding with rapid KYC verification'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'virtual-accounts-escrow',
    title: 'Virtual Accounts & Smart Escrow',
    shortTag: 'Auto-Reconciliation Accounts',
    category: 'banking',
    colorTheme: 'blue',
    iconType: 'ShieldCheck',
    tagline: 'Create unique virtual bank accounts for every customer with automatic ledger posting.',
    description: 'Eliminate manual reconciliation with dedicated virtual account numbers and dynamic UPI IDs.',
    partnerIntegrations: ['ICICI Bank', 'Yes Bank', 'Axis Bank', 'Cashfree', 'RazorpayX'],
    settlementTime: 'Instant auto-credit',
    whatWeProvide: [
      'Generate unlimited virtual account numbers (VAN) with unique alphanumeric prefixes',
      'Instant settlement and automated ledger posting upon receiving NEFT/RTGS/IMPS/UPI',
      'Closed-loop smart escrow accounts for marketplaces, logistics, and real estate platforms',
      'Real-time webhooks notifying customer payment receipt in milliseconds'
    ],
    directActionText: 'Submit Request',
  },

  // ================= INSURANCE (IRDA BACKED PORTAL) =================
  {
    id: 'health-insurance',
    title: 'Health & Mediclaim Insurance',
    shortTag: 'Cashless Hospitalization',
    category: 'insurance',
    colorTheme: 'green',
    iconType: 'HeartPulse',
    isInsurance: true,
    tagline: 'Comprehensive cashless health cover across 12,000+ top Indian hospitals.',
    description: 'Individual and family floater policies underwritten by premier IRDA-licensed insurers via our live insurance portal.',
    partnerIntegrations: ['Star Health', 'HDFC ERGO', 'Care Health', 'Niva Bupa', 'ICICI Lombard'],
    commissionInfo: 'Partner Commission: Up to 35% on annual premium',
    whatWeProvide: [
      'Cashless hospital claims at 12,000+ network hospitals with zero room rent capping options',
      'Comprehensive coverage for pre & post-hospitalization, daycare, and ambulance expenses',
      'Critical illness riders, organ donor cover, and annual health checkups included',
      'Best-in-class partner referral commissions up to 35% on every policy booked'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'life-insurance',
    title: 'Life & Term Insurance',
    shortTag: 'High Sum-Assured Cover',
    category: 'insurance',
    colorTheme: 'green',
    iconType: 'ShieldCheck',
    isInsurance: true,
    tagline: 'Term life security up to ₹5 Crores with attractive POSP referral payouts.',
    description: 'Financial protection for families with critical illness and accidental disability riders on our live insurance portal.',
    partnerIntegrations: ['Tata AIA', 'HDFC Life', 'ICICI Prudential', 'Max Life', 'LIC'],
    commissionInfo: 'Partner Commission: Up to 40% on first year premium',
    whatWeProvide: [
      'High sum-assured life cover from ₹50 Lakhs up to ₹5 Crores at lowest monthly premiums',
      'Accelerated terminal illness payout and accidental total permanent disability benefit',
      'Tax savings under Section 80C and Section 10(10D) of Income Tax Act',
      'Highest market partner commissions up to 40% for POSP advisors and referrers'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'motor-insurance',
    title: 'Motor & Commercial Fleet Insurance',
    shortTag: 'Instant 2-Minute Policy',
    category: 'insurance',
    colorTheme: 'green',
    iconType: 'Car',
    isInsurance: true,
    tagline: 'Instant paperless insurance for 2-wheelers, private cars, and commercial trucks.',
    description: 'Zero depreciation, roadside assistance, and instant digital policy download.',
    partnerIntegrations: ['Bajaj Allianz', 'ICICI Lombard', 'HDFC ERGO', 'Go Digit', 'TATA AIG'],
    commissionInfo: 'Partner Commission: Up to 25% POSP payout',
    whatWeProvide: [
      'Instant paperless policy generation in under 2 minutes without prior inspection',
      'Bumper-to-bumper zero depreciation and 24/7 roadside breakdown assistance',
      'Special discounted fleet packages for commercial transport trucks and taxis',
      'Lucrative POSP commission slabs up to 25% per policy'
    ],
    directActionText: 'Submit Request',
  },
  {
    id: 'shop-fire-insurance',
    title: 'Shopkeeper & Commercial Fire Insurance',
    shortTag: 'Business Property Cover',
    category: 'insurance',
    colorTheme: 'green',
    iconType: 'Building',
    isInsurance: true,
    tagline: 'Protection for shop inventory, godowns, machinery, and accidental fire damage.',
    description: 'Safeguard your commercial premises against fire, flood, burglary, and natural calamities.',
    partnerIntegrations: ['ICICI Lombard', 'HDFC ERGO', 'United India', 'New India Assurance'],
    commissionInfo: 'Partner Commission: Up to 25% annual payout',
    whatWeProvide: [
      'Coverage for building structure, plant & machinery, raw material stocks, and finished goods',
      'Protection against fire, lightning, explosion, storm, flood, and earthquake',
      'Burglary and housebreaking theft coverage with fast claim settlement',
      'Tailored policies for supermarkets, textile shops, electronics showrooms, and warehouses'
    ],
    directActionText: 'Submit Request',
  },

  // ================= BUILD & INVEST =================
  {
    id: 'build-and-invest',
    title: 'Build & Invest Tech Partnerships',
    shortTag: 'Capital & Technology Incubation',
    category: 'build-invest',
    colorTheme: 'blue',
    iconType: 'Rocket',
    tagline: 'We invest in ambitious technology partners and high-potential fintech founders.',
    description: 'Co-building enterprise platforms, backing innovative ideas with seed capital, and providing regulatory banking pipes.',
    partnerIntegrations: ['Fi Pay Bills Ventures', 'Banking Alliances', 'Tech Labs'],
    settlementTime: 'Incubation & Seed Funding',
    whatWeProvide: [
      'Seed capital investment and technology co-founding for viable business models',
      'Direct access to pre-integrated Indian payment gateway aggregators and banking APIs',
      'Regulatory guidance and compliance support for Indian fintech licensing',
      'Engineering mentorship, architecture design, and scalable infrastructure support'
    ],
    directActionText: 'Submit Request',
  },
];

export const IRDA_INSURANCE_PARTNERS = [
  'HDFC ERGO',
  'Star Health',
  'Care Health',
  'ICICI Lombard',
  'Tata AIA',
  'HDFC Life',
  'Bajaj Allianz',
  'Niva Bupa',
  'Max Life',
];

export const GOOGLE_REVIEWS_DATA = [
  {
    id: 'rev-1',
    authorName: 'Rajesh K. Varma',
    companyOrRole: 'Founder, Varma Retail Mart',
    city: 'Hyderabad',
    avatarText: 'RV',
    rating: 5,
    timeAgo: '1 day ago',
    solutionTag: 'Subpaisa & Payment Gateway',
    reviewText: 'Outstanding support from Fi Pay Bills team in Hyderabad. We got Subpaisa and multi-gateway aggregation integrated in less than 24 hours. T+0 settlements are genuinely instantaneous with zero downtime.',
    verifiedBadge: 'Verified Google Review'
  },
  {
    id: 'rev-2',
    authorName: 'Sneha Venkatesh',
    companyOrRole: 'CTO, FinScale Logistics',
    city: 'Bangalore',
    avatarText: 'SV',
    rating: 5,
    timeAgo: '3 days ago',
    solutionTag: 'Validation Kit (PAN, Aadhaar, Bank Details)',
    reviewText: 'Their Validation Kit API suite is exceptional! The ₹1 Penny Drop and PAN/Aadhaar OCR APIs slashed our customer onboarding time from 30 minutes to under 5 seconds. All banks are supported with 99.9% uptime.',
    verifiedBadge: 'Verified Merchant'
  },
  {
    id: 'rev-3',
    authorName: 'Amitabh Sharma',
    companyOrRole: 'MD, Sharma Logistics & Warehousing',
    city: 'Mumbai',
    avatarText: 'AS',
    rating: 5,
    timeAgo: '5 days ago',
    solutionTag: 'Instant Payouts & All Banks',
    reviewText: 'We disburse vendor settlements and driver payouts 24/7 across SBI, ICICI, HDFC, and Axis Bank. Instant T+0 and T+1 rails work without any hiccups even on bank holidays. Best payout solution in India!',
    verifiedBadge: 'Verified Google Review'
  },
  {
    id: 'rev-4',
    authorName: 'Priya Sundaram',
    companyOrRole: 'Director, Sundaram Textiles',
    city: 'Chennai',
    avatarText: 'PS',
    rating: 5,
    timeAgo: '1 week ago',
    solutionTag: 'Apply Razorpay & Apply Cashfree',
    reviewText: 'Applying for Razorpay and Cashfree through Fi Pay Bills was the smoothest experience. Their team expedited KYC approval in 2 hours and set up our merchant sub-accounts at the lowest MDR rates.',
    verifiedBadge: 'Verified Business'
  },
  {
    id: 'rev-5',
    authorName: 'Vikram Patel',
    companyOrRole: 'Managing Partner, Patel Enterprises',
    city: 'Ahmedabad',
    avatarText: 'VP',
    rating: 5,
    timeAgo: '1 week ago',
    solutionTag: 'Multi-Lender Loan & EMI Calculator',
    reviewText: 'The highlighted Loan & EMI calculator on their site is accurate and straightforward. Applied for a ₹25 Lakhs business expansion loan and received multi-lender sanctions within 48 hours without any collateral.',
    verifiedBadge: 'Verified Google Review'
  },
  {
    id: 'rev-6',
    authorName: 'Harpreet Singh',
    companyOrRole: 'CEO, NorthTech Solutions',
    city: 'Delhi NCR',
    avatarText: 'HS',
    rating: 5,
    timeAgo: '2 weeks ago',
    solutionTag: 'Insurance Portal Live',
    reviewText: 'Super convenient insurance portal! Booked commercial fleet insurance and group health cover for our 50 employees. Instant policy download and great POSP partner commission credited directly to bank.',
    verifiedBadge: 'Verified Google Review'
  },
  {
    id: 'rev-7',
    authorName: 'Karthik Reddy',
    companyOrRole: 'Proprietor, Sri Balaji Supermarket',
    city: 'Hyderabad',
    avatarText: 'KR',
    rating: 5,
    timeAgo: '2 weeks ago',
    solutionTag: 'Smart POS & Audio Soundbox',
    reviewText: 'Got the 4G Soundbox with loud Telugu voice alerts and the Android Smart POS. Settlement lands in our SBI current account next morning with zero discrepancies. Highly recommended!',
    verifiedBadge: 'Verified Merchant'
  },
  {
    id: 'rev-8',
    authorName: 'Naveen Choudhury',
    companyOrRole: 'Fintech DSA Partner',
    city: 'Pune',
    avatarText: 'NC',
    rating: 5,
    timeAgo: '3 weeks ago',
    solutionTag: 'Sign In / Partner Portal',
    reviewText: 'The partner sign-in portal makes tracking loans, payouts, and monthly referral commissions completely seamless. Direct IMPS payout into bank account every single cycle. Trustworthy and reliable.',
    verifiedBadge: 'Verified Google Review'
  }
];

// Options shown in the "I'm interested in" dropdown of the enquiry form.
export const INQUIRY_SOLUTIONS = [
  'Payment Gateway (Pay-In)',
  'Apply Razorpay Onboarding',
  'Apply Cashfree Onboarding',
  'Subpaisa Payment Suite',
  'UPI Intent & Dynamic QR Suite',
  'Multi-Bank Card & Net Banking Switch',
  'Instant Payouts & Disbursals (T+0 / T+1)',
  'Bulk Vendor & Salary Payout Engine',
  'Connected Corporate Banking Payouts',
  'Validation Kit (PAN, Aadhaar, Bank & more)',
  'Fintech APIs (Payout, AEPS, MATM, DMT, CMS, Recharge, Travel)',
  'Business & MSME Loans',
  'Personal Loans',
  'Home Loans & Loan Against Property (LAP)',
  'Equipment & Machinery Financing',
  'Health & Mediclaim Insurance',
  'Life & Term Insurance',
  'Motor & Commercial Fleet Insurance',
  'Shopkeeper & Commercial Fire Insurance',
  'Smart Android POS Machines',
  'Multilingual Audio Soundboxes',
  'Merchant Banking & Current Accounts',
  'Business & Commercial Credit Cards',
  'Virtual Accounts & Smart Escrow',
  'Build & Invest Tech Partnerships',
  'Become a Partner (Refer & Earn)',
  'Merchant Feedback',
  'General Enquiry',
];
